import React, {useEffect, useState} from 'react';
import { Button, Dialog, Grid, Box } from '@mui/material';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import styles from '../ConfirmDeletionModal/styles.module.scss';
import '../ConfirmDeletionModal/styles.module.scss';
import { isFunc } from '@utils/functions';


const ConfirmNotificationModal = ({ open, setOpen, parameters }) => {
  const dimensions = useSelector(state => state.dimensions);
  const [isAlreadyClicked, setIsAlreadyClicked] = useState(false);

  useEffect(() => {
    if (open) setIsAlreadyClicked(false);
  }, [open]);//eslint-disable-line

  return (
    <>
      <Dialog open={open} className={'ConfirmDeletionDialog'} onClose={() => {}} fullScreen={dimensions.isScreenLessSM} data-testid="dialog-confirm-notification">
        <MuiDialogTitle>
          <Box className={`${styles.modalTitle} ${dimensions.isScreenLessMD ? styles.mobile : ''}`}>Confirm notification</Box>
        </MuiDialogTitle>
        <MuiDialogContent>
          <Box className={styles.text}>
            <p>{
              parameters?.onlyMainUser
                ? 'Do you want to notify a customer about the change?'
                : 'Do you want to notify all applicants and team members about the change?'
            }</p>
          </Box>
        </MuiDialogContent>
        <MuiDialogActions>
          <Grid container justifyContent="space-between">
            <Button
              className={`${styles.actionButton} ${styles.secondary}`}
              data-testid="button-confirm-notification-no"
              onClick={() => {
                if (isFunc(parameters?.noAction) && !isAlreadyClicked) {
                  setIsAlreadyClicked(true);
                  parameters.noAction();
                }
                setOpen(false);
              }}
              color="secondary"
              variant="outlined"
              type="button"
              disableElevation
            >
              NO
            </Button>
            <Button
              className={`${styles.actionButton}`}
              data-testid="button-confirm-notification-yes"
              type="button"
              variant="contained"
              color="primary"
              onClick={() => {
                if (isFunc(parameters?.yesAction) && !isAlreadyClicked) {
                  setIsAlreadyClicked(true);
                  parameters.yesAction();
                }
                setOpen(false);
              }}
            >
              YES
            </Button>
          </Grid>
        </MuiDialogActions>
      </Dialog>
    </>
  );
};

ConfirmNotificationModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  parameters: PropTypes.object
};

export default ConfirmNotificationModal;

